export const actions = {
  ETIQUETA_FAMILIA_LOAD_REQUESTED: 'ETIQUETA_FAMILIA_LOAD_REQUESTED',
  ETIQUETA_FAMILIA_LOAD_SUCCEEDED: 'ETIQUETA_FAMILIA_LOAD_SUCCEEDED',
  ETIQUETA_FAMILIA_LOAD_FAILED: 'ETIQUETA_FAMILIA_LOAD_FAILED',

  ETIQUETA_FAMILIA_INSERT_REQUESTED: 'ETIQUETA_FAMILIA_INSERT_REQUESTED',
  ETIQUETA_FAMILIA_INSERT_SUCCEEDED: 'ETIQUETA_FAMILIA_INSERT_SUCCEEDED',
  ETIQUETA_FAMILIA_INSERT_FAILED: 'ETIQUETA_FAMILIA_INSERT_FAILED',

  ETIQUETA_FAMILIA_UPDATE_REQUESTED: 'ETIQUETA_FAMILIA_UPDATE_REQUESTED',
  ETIQUETA_FAMILIA_UPDATE_SUCCEEDED: 'ETIQUETA_FAMILIA_UPDATE_SUCCEEDED',
  ETIQUETA_FAMILIA_UPDATE_FAILED: 'ETIQUETA_FAMILIA_UPDATE_FAILED',

  ETIQUETA_FAMILIA_DELETE_REQUESTED: 'ETIQUETA_FAMILIA_DELETE_REQUESTED',
  ETIQUETA_FAMILIA_DELETE_SUCCEEDED: 'ETIQUETA_FAMILIA_DELETE_SUCCEEDED',
  ETIQUETA_FAMILIA_DELETE_FAILED: 'ETIQUETA_FAMILIA_DELETE_FAILED',
}

export const getEtiquetasFamiliaAction = dispatch => {
  dispatch({
    type: actions.ETIQUETA_FAMILIA_LOAD_REQUESTED,
  })
}

export const insertEtiquetaFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_FAMILIA_INSERT_REQUESTED,
    payload,
  })
}

export const updateEtiquetaFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_FAMILIA_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteEtiquetaFamiliaAction = (dispatch, payload) => {
  dispatch({
    type: actions.ETIQUETA_FAMILIA_DELETE_REQUESTED,
    payload,
  })
}
